// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.TextareaField = (function(){
  function TextareaField(cfg, index, form) {
    this._super.apply(this, arguments); // call generic TextField constructor
  }
  TextareaField.prototype = {
    _rows: 1,
    rows: 2, // for template
    expanding: false,
    placeholder: null, // if false, disable placeholder. If falsy (but not false), use label instead
    _template: 
      '<div class="form-group">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-9">' +
          '<textarea class="form-control <%=expanding?"expand":""%>"'+
            ' id="<%=id%>" name="<%=name%>"'+
            ' placeholder="<%=placeholder===false? \'\' : placeholder || label%>"'+
            ' style="resize: none;" rows="<%=rows%>"'+
            ' <%=expanding?\'data-min-rows="\'+rows+\'"\':\'\'%>'+
          '></textarea>' +
        '</div>' +

      '<% if (errorText) { %>' +
        '<div class="col-sm-9 col-sm-offset-3 error-text">' +
          '<p><%=errorText%></p>' +
        '</div>' +
      '<% } %>' +

      '</div>',
  };

  // inherit from generic field
  PD.forms.fields.register(["textarea", "TextareaField"], TextareaField, PD.forms.fields.TextField);

  return TextareaField;
})();